import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { BaseModalComponent } from '../../../core/layout/components/abstracts/base-modal.component';
import { heightDirective } from '../../directives/height.directive';
import { FormsModule } from '@angular/forms';
import { FormControlComponent } from '../form-control/form-control.component';
import { TranslatePipe } from '../../pipes/trans.pipe';
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'app-add-note-modal',
  standalone: true,
  imports: [
    ModalComponent,
    TranslatePipe,
    FormControlComponent,
    FormsModule,
    heightDirective
  ],
  templateUrl: './add-note-modal.component.html',
  styleUrl: './add-note-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddNoteModalComponent extends BaseModalComponent<string> {

  @Output() noteChange = new EventEmitter<string>();

  public note: string;

  public override open(val: string): void {
    super.open(val);
    this.note = val;
  }

  public addNote(): void {
    this.noteChange.emit(this.note);
    this.close();
  }
}
